import type { I18NKey } from "@grafit/i18n";
import { SSO_ERROR_VINCI_ACCOUNT_NOT_LINKED, SSO_PROVIDER_ID_VINCI } from "@grafit/shared/services/sso";

const UUID_PATTERN = /^[\da-f]{8}-(?:[\da-f]{4}-){3}[\da-f]{12}$/i;

const KNOWN_SSO_ERROR_MESSAGE_KEYS = new Map<string, I18NKey>([
  ["account not linked", "sso.error.account-not-linked"],
  ["signup disabled", "sso.error.account-not-linked"],
  [SSO_ERROR_VINCI_ACCOUNT_NOT_LINKED, "sso.error.vinci-group-email-not-linked"],
  ["state_mismatch", "sso.error.state-mismatch"],
]);

function isAccountNotLinkedSSOError(error: string | undefined): boolean {
  return error === "account not linked" || error === "signup disabled" || error === SSO_ERROR_VINCI_ACCOUNT_NOT_LINKED;
}

export function getSSOErrorMessageKey({
  error,
  providerId,
}: {
  error: string | undefined;
  providerId: string | false | null;
}): I18NKey {
  if (providerId === SSO_PROVIDER_ID_VINCI && isAccountNotLinkedSSOError(error)) {
    return "sso.error.vinci-group-email-not-linked";
  }

  return KNOWN_SSO_ERROR_MESSAGE_KEYS.get(error ?? "") ?? "sso.error.unknown-error";
}

export function shouldAlertDevsForSSOError(error: string | undefined): boolean {
  return !KNOWN_SSO_ERROR_MESSAGE_KEYS.has(error ?? "");
}

export function getSSOErrorReference({
  error,
  errorDescription,
}: {
  error: string | undefined;
  errorDescription: string | undefined;
}): string | null {
  if (error !== SSO_ERROR_VINCI_ACCOUNT_NOT_LINKED || !errorDescription || !UUID_PATTERN.test(errorDescription)) {
    return null;
  }

  return errorDescription;
}
